import { HHTypography } from '@hinge-health/react-component-library';
import { ActionTypeDisplayText, GridLevelName } from './grid-types';

export interface PanelTitleProps {
  actionType: ActionTypeDisplayText;
  rowCount: number;
  gridLevel: GridLevelName;
}

export const PanelTitle = ({
  actionType,
  rowCount,
  gridLevel,
}: PanelTitleProps): JSX.Element => {
  const entity = rowCount > 1 ? `${gridLevel}s` : gridLevel;
  const message = `${actionType} ${rowCount} ${entity}`;
  return <HHTypography hhVariant="section-title">{message}</HHTypography>;
};
